<script src="../../../locales/en/components/dashboard.js"></script>
<template>
  <div class="template-wrapper">
    <div class="sites">
      <div class="toolbar sites__toolbar row justify-content-between">
        <div class="toolbar__left sites__actions col-12 col-lg-auto">
          <b-dropdown id="actions-dropdown-sites"
                      v-bind:disabled="!showActions"
                      v-bind:text="$t('site.actions')"
                      variant="outline-primary">
            <b-dropdown-item v-on:click="backupTestAllSites">
              {{ $t('site.backupandtestnow') }}
            </b-dropdown-item>
            <b-dropdown-item v-on:click="backupAllSites">
              {{ $t('site.backupnow') }}
            </b-dropdown-item>
            <b-dropdown-item v-on:click="updateAllExtensionsForSelectedSites">
              {{ $t('site.updateall') }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-on:click="localRemoveAllSelectedSites">
              {{ $t('site.remove') }}
            </b-dropdown-item>
          </b-dropdown>
          <button v-show="showActions" class="btn btn--primary" v-on:click="refreshDataForSelectedSites">
            {{ $t('site.refreshdata') }}
          </button>
          <button v-show="showActions" class="btn btn--primary" v-on:click="updateCoreForSelectedSites">
            {{ $t('site.updatecore') }}
          </button>
        </div>
        <div class="toolbar__right sites__search col-12 col-lg-auto">
          <div>
            <b-input-group>
              <b-form-input
                v-model="searchTerm"
                class="form-control search mb-2 mb-lg-0"
                type="search"
                v-bind:placeholder="$t('site.entersitename')"
                v-on:blur="changeSearch"
                v-on:keyup.enter="changeSearch"
              />
              <b-input-group-append>
                <button class="btn btn-primary">
                  <font-awesome-icon :icon="['fal','search']" class="fa-icon"></font-awesome-icon>
                </button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="ml-lg-2 d-inline-block mb-2 mb-lg-0">
            <b-button
              :aria-expanded="showFilter ? 'true' : 'false'"
              :class="showFilter ? null : 'collapsed'"
              aria-controls="fbar-collapse"
              variant="outline-primary"
              @click="showFilter = !showFilter"
            >
              <span v-show="showFilter">{{ $t('sites.hidefilter') }}</span>
              <span v-show="!showFilter">{{ $t('sites.showfilter') }}</span>
            </b-button>
          </div>
          <div class="ml-2 d-inline-block mb-2 mb-lg-0">
            <b-dropdown id="columns-dropdown"
                        v-bind:text="$t('tableheadings.columns')"
                        variant="outline-primary"
            >
              <b-dropdown-form>
                <b-form-checkbox-group
                  id="column-select"
                  v-model="tableColumns"
                  name="columnselection"
                  stacked
                >
                  <b-form-checkbox
                    v-for="col in columns"
                    :key="col.name"
                    :value="col.name"
                    class="mb-3 m-2"
                  >
                    {{ $t('tableheadings.' + col.name ) }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-dropdown-form>
            </b-dropdown>
          </div>
          <div class="ml-lg-2">
            <b-form-select
              v-model="limit"
              :options="limitOptions"
              @change="limitChange"
            >
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="filterbar col-12">
        <b-collapse id="fbar-collapse" v-model="showFilter">
          <div class="border-top py-4">
            <b-row>
              <b-col lg="3" md="6">
                <b-form-select
                  v-model="tagId"
                  :options="selectTags"
                  class="mr-md-1"
                  v-on:change="changeSearch"
                >
                  <template v-slot:first>
                    <option value="">{{ $t('site.tagfilter') }}</option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col lg="3" md="6">
                <b-form-select
                  v-model="appFilter"
                  :options="appOptions"
                  class="mr-md-1"
                  v-on:change="changeSearch"
                >
                  <template v-slot:first>
                    <option value="">{{ $t('site.appfilter') }}</option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col lg="3" md="6">
                <b-form-select
                  v-model="phpFilter"
                  :options="phpOptions"
                  class="mr-md-1"
                  v-on:change="changeSearch"
                >
                  <template v-slot:first>
                    <option value="">{{ $t('site.phpfilter') }}</option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col lg="3" md="6">
                <b-form-select
                  v-model="dbFilter"
                  :options="dbOptions"
                  class="mr-md-1"
                  v-on:change="changeSearch"
                >
                  <template v-slot:first>
                    <option value="">{{ $t('site.dbfilter') }}</option>
                  </template>
                </b-form-select>
              </b-col>
            </b-row>
          </div>
        </b-collapse>
      </div>
      <div class="table-responsive">
        <table class="table table--overview">
          <thead>
          <tr>
            <th class="small">
              <b-form-checkbox
                v-model="allSelected"
                v-on:change="toggleAll"
              >
              </b-form-checkbox>
            </th>
            <th class="text-center avatar">
              <span class="colname">
                  {{ $t('tableheadings.updates') }}
              </span>
            </th>
            <table-heading
              class="text-center"
              v-bind="{name: 'name', selected: ['name'], sortEnabled: true, sort: sort, dir: dir}"
              @notifysort="sortColumn"
            ></table-heading>

            <table-heading
              v-for="(col, index) in columns"
              :key="index"
              class="text-center"
              v-bind="{name: col.name, selected: tableColumns, sortEnabled: col.sortEnabled, sort: sort, dir: dir}"
              @notifysort="sortColumn"
            >
            </table-heading>
          </tr>
          </thead>
          <tbody>
          <site-item
            v-for="site in sites"
            :key="site.id"
            v-bind="site"
          >
          </site-item>
          </tbody>
        </table>
      </div>
      <b-pagination
        v-show="showPagination"
        v-model="currentPage"
        align="left"
        v-bind:per-page="limit"
        v-bind:total-rows="total"
        v-on:change="goToPage"
      >
      </b-pagination>
    </div>
    <site-detail></site-detail>
    <div v-if="!isLoading">
      <onboarding v-if="showOnboarding"></onboarding>
      <empty-list v-if="showEmpty" @resetFilters="resetFilters"></empty-list>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import SiteItem from './SiteItem'
import SiteDetail from './SiteDetail'
import Onboarding from './Onboarding'
import TableHeading from '../Common/TableHeading'
import mixins from '../../mixins'
import EmptyList from '@/components/Common/EmptyList.vue'

export default {

  name: 'Sites',

  components: {
    SiteItem,
    SiteDetail,
    Onboarding,
    TableHeading,
    EmptyList
  },

  mixins: [mixins],

  props: {},

  computed: {

    ...mapState('site', {
      siteSelected: state => state.siteSelected,
      allSelectedState: state => state.allSelected,
      globalSites: state => state.sites,
      siteFilter: state => state.sitesFilter
    }),

    ...mapGetters('tag', ['selectTags']),

    ...mapGetters('common', ['isLoading']),

    ...mapGetters('local', ['getListLimit']),

    ...mapGetters('local', { getColumns: 'getSitesColumns' }),

    showEmpty () {
      return this.sites.length === 0 && this.isFiltered === true
    },

    showOnboarding () {
      return this.sites.length === 0 && this.isFiltered === false
    },

    isFiltered () {
      return this.searchTerm !== '' ||
        this.tagId !== '' ||
        this.appFilter !== '' ||
        this.phpFilter !== '' ||
        this.dbFilter !== ''
    },

    allSelected: {
      get () {
        return this.allSelectedState
      },
      set (value) {
        // just do nothing
      }
    },

    showActions () {
      return this.siteSelected.length > 0
    },

    appOptions () {
      let result = []

      this.siteFilter.app_version.forEach((element) => {
        result.push(
          {value: element.app_type + '|' + element.app_version, text: element.app_type + ' ' + element.app_version}
        )
      })

      return result
    },

    phpOptions () {
      let result = []

      this.siteFilter.phpversion.forEach((element) => {
        result.push(
          {value: element.phpversion, text: element.phpversion}
        )
      })

      return result
    },

    dbOptions () {
      let result = []

      this.siteFilter.database_version.forEach((element) => {
        result.push(
          {value: element.database_version, text: element.database_version}
        )
      })

      return result
    }
  },

  data () {
    return {
      sites: [],
      currentPage: 1,
      total: 1,
      totalPages: 1,
      sort: 'name',
      dir: 'asc',
      searchTerm: '',
      tagId: '',
      appFilter: '',
      phpFilter: '',
      dbFilter: '',
      reportFilter: '',
      showFilter: false,
      defaultSelectedColumns: [
        'app_version',
        'tls_expiration',
        'phpversion',
        'database_version',
        'last_backup',
        'last_checked_backup'
      ],
      columns: [
        { name: 'app_version', sortEnabled: true },
        { name: 'tls_expiration', sortEnabled: false },
        { name: 'phpversion', sortEnabled: true },
        { name: 'database_version', sortEnabled: true },
        { name: 'last_backup', sortEnabled: true },
        { name: 'last_checked_backup', sortEnabled: true },
        { name: 'report_setup', sortEnabled: false },
        { name: 'disabled_update_sites', sortEnabled: false },
        { name: 'update_channel', sortEnabled: true }
      ]
    }
  },

  methods: {

    ...mapMutations('site', [
      'setSelectAll',
      'unSelectAll'
    ]),

    ...mapActions('backup', [
        'backupAllSites',
        'backupTestAllSites'
      ]
    ),

    ...mapActions('core', [
        'updateCoreForSelectedSites'
      ]
    ),

    ...mapActions('site', [
      'getSites',
      'getSitesFilter',
      'refreshDataForSelectedSites',
      'updateAllExtensionsForSelectedSites',
      'addNewSite'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    ...mapMutations('local', [
      'setListLimit'
    ]),

    ...mapMutations('local', { setColumns: 'setSitesColumns' }),

    resetFilters () {
      this.startLoading()

      this.appFilter = ''
      this.dbFilter = ''
      this.phpFilter = ''
      this.searchTerm = ''
      this.tagId = ''

      this.goToPage(1)
    },

    changeSearch () {
      this.unSelectAll()
      this.goToPage(1)
    },

    goToPage (page) {
      let payload = {
        page: page,
        limit: this.limit,
        sort: this.sort,
        dir: this.dir,
        search: this.searchTerm,
        tagId: this.tagId,
        appVersion: this.appFilter,
        phpVersion: this.phpFilter,
        databaseVersion: this.dbFilter
      }

      this.getSites(payload).then(
        response => {
          /*
              Don't use the repose data because we are converting data for easier usage, this is saved
              locally in the globalSites var to avoid naming conflicts
          */

          this.preparePage(this.globalSites)
          this.endLoading()
        }
      )
    },

    localRemoveAllSelectedSites () {
      this.$router.push({
        name: 'sitesDestroy'
      })
    },

    preparePage (data) {
      let meta = data.meta

      this.limit = meta.pagination.per_page
      this.total = meta.pagination.total
      this.totalPages = meta.pagination.total_pages
      this.currentPage = meta.pagination.current_page

      this.sites = []

      data.data.forEach((e) => {
        this.sites.push(e)
      })
    },

    toggleAll (e) {
      if (this.allSelected) {
        this.unSelectAll(e)
      } else {
        this.setSelectAll(e)
      }
    }
  },

  mounted () {
    if (this.getColumns.length === 0) {
      this.setColumns(this.defaultSelectedColumns)
    }
  },

  watch: {
    '$route.params.tagId': function () {
      this.tagId = (this.$route.params.tagId) ? this.$route.params.tagId : ''
      this.goToPage(1)
    }
  },

  async created () {
    // Add new site if present
    if (sessionStorage.getItem('bm-siteconfig')) {
      await this.addNewSite(JSON.parse(sessionStorage.getItem('bm-siteconfig')))

      sessionStorage.removeItem('bm-siteconfig')
    }

    if (this.$route.params.tagId) {
      this.tagId = this.$route.params.tagId
    }

    this.goToPage(1)
    this.getSitesFilter()
  }
}
</script>
